function toggleVisibility(className, showItem) {
  let elements = document.getElementsByClassName(className);
  for (let i = 0; i < elements.length; i++) {
    if (showItem) {
      elements[i].style.display = '';
    } else {
      elements[i].style.display = 'none';
    }
  }
}

function unloadMessage (e) {
  var confirmationMessage = `Are you sure you want to leave this page? All your changes will be lost.`;
  e.returnValue = confirmationMessage;
  return confirmationMessage;
}

function simulateClick (elem) {
	var evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window
	});
	var canceled = !elem.dispatchEvent(evt);
};